<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #0d53ee">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-format-list-bulleted</v-icon
              >
              Producer Schedule
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-3">
      <v-list v-if="producerSchedule.length > 0" dense>
        <v-list-item
          v-for="(producer, index) in producerSchedule"
          :key="producer"
          class="d-flex align-center pa-0"
          style="min-height: 24px"
        >
          <v-list-item-icon
            class="my-0"
            style="
              min-width: 16px;
              margin-right: 4px;
              display: flex;
              align-items: center;
            "
          >
            <v-icon v-if="producer === headBlockProducer" small color="black"
              >mdi-circle</v-icon
            >
            <span v-else :style="{ ...indexStyle, display: 'inline-block' }">{{
              (index + 1).toString().padStart(2, '0')
            }}</span>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title
              :style="
                producer === headBlockProducer
                  ? currentProducerStyle
                  : otherProducerStyle
              "
            >
              {{ producer }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div
        v-else
        class="my-2"
        style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
      >
        Waiting to receive data
      </div>
    </v-col>
  </v-card>
</template>

<script>
export default {
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    producerSchedule() {
      const scheduleValue =
        this.$store.state.metrics.metric[
          this.getMetricId('Producer', 'ProducerSchedule')
        ];
      if (scheduleValue) {
        try {
          return JSON.parse(scheduleValue);
        } catch (e) {
          return [];
        }
      } else {
        return [];
      }
    },
    headBlockProducer() {
      return this.$store.state.metrics.metric[
        this.getMetricId('Node', 'Head_Block_Producer')
      ];
    },
    currentProducerStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '600',
        marginRight: '4px',
      };
    },
    otherProducerStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '0.875rem',
        fontWeight: '400',
      };
    },
    indexStyle() {
      return {
        fontFamily: 'Inter',
        fontSize: '10px',
        lineHeight: '10px',
        fontWeight: '400',
        verticalAlign: 'middle',
        color: '#a0a0a0',
        width: '16px',
        textAlign: 'center',
      };
    },
  },
  methods: {
    getMetricId(module, name) {
      const alert = this.node?.alerts.find(
        (alert) => alert.metric === `${module}/${name}`
      );
      return alert ? alert.id : null;
    },
  },
};
</script>
